import React, { Component } from "react";

import { SeedMeter } from "../SeedMeter";

export default class CoachComposer extends Component {
  render() {
    const {
      textareaRef,
      input,
      sending,
      onChange,
      onKeyDown,
      onSend,
      seedsUsed,
    } = this.props;

    return (
      <div className="coach-input">
        <textarea
          ref={textareaRef}
          rows={2}
          placeholder={sending ? "Thinking..." : "Type a message..."}
          value={input}
          disabled={sending}
          onChange={onChange}
          onKeyDown={onKeyDown}
          className="coach-textarea"
        />
        <div className="coach-send-column">
          <button className="btn primary" disabled={sending || !input.trim()} onClick={onSend}>
            Send <span className="seed-price-label">1 fig seed</span>
          </button>
          {typeof seedsUsed === "number" && <SeedMeter seedsUsed={seedsUsed} />}
        </div>
      </div>
    );
  }
}